import { useContext } from 'react'
import PropTypes from 'prop-types'

import { useSetState } from '@domain-group/react-hooks'

import {
  Box, Button, Form, ModalContext, SectionDivider, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject, findArrayIndex, generateID } from '@domain-group/javascript-utils'

import DomainListItem from './components/DomainListItem'
import useManageBrandSSOModal from './hooks/useManageBrandSSOModal'

const defaultState = {
  value: '',
}

const ManageBrandSSOModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updateBrand } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { value } = state

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { brand } = modalPayload

  const {
    callbacks: {
      updateSSODomains,
      updateFn,
    },
    entityState,
    handlers,
    updating,
  } = useManageBrandSSOModal({ brand })

  const ssoApi = digObject(entityState, 'options.sso_api')
  const ssoDomains = digObject(entityState, 'options.sso_domains', [])
  const hasSSODomains = !!ssoDomains.length
  const duplicateExists = findArrayIndex(ssoDomains, { title: value }, { useObjectKey: 'title' }) !== -1

  const manageBrandSSOModalPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Brand Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Manage" titleSecondLine="SSO API" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <Form.Field label="SSO API">
            <select
              name="options.sso_api"
              value={ssoApi}
              {...handlers}
            >
              <option value="">None</option>
              <option value="ray_white">Ray White</option>
            </select>
          </Form.Field>

          {ssoApi && (
            <Form.Field label="SSO Domains" marginTop="large">
              <Box>
                <input
                  onChange={e => setState({ value: e.target.value })}
                  placeholder="Enter Domain"
                  type="text"
                  value={value}
                />

                <Button
                  buttonStyle="ghostEdit"
                  disabled={duplicateExists || !value}
                  marginLeft="medium"
                  onClick={() => updateSSODomains({ title: value, key: generateID() })}
                  size="medium"
                  width="auto"
                >
                  Add Domain
                </Button>
              </Box>
            </Form.Field>
          )}

          {hasSSODomains && ssoApi && (
            <>
              <SectionDivider marginTop="large">DOMAINS ADDED</SectionDivider>

              <Box flexDirection="column">
                {ssoDomains.map(domain => (
                  <DomainListItem
                    domain={domain}
                    entityState={entityState}
                    callbacks={{ updateSSODomains }}
                    key={domain.key}

                  />
                ))}
              </Box>
            </>
          )}
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateBrand(manageBrandSSOModalPayload)}
          size="large"
        >
          Save SSO API Settings
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManageBrandSSOModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManageBrandSSOModal.defaultProps = {
  modalKey: 'ManageBrandSSOModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManageBrandSSOModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
